import { render, staticRenderFns } from "./huovTravelParty.vue?vue&type=template&id=b2cedc70&scoped=true"
import script from "./huovTravelParty.vue?vue&type=script&lang=js"
export * from "./huovTravelParty.vue?vue&type=script&lang=js"
import style0 from "./huovTravelParty.vue?vue&type=style&index=0&id=b2cedc70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cedc70",
  null
  
)

export default component.exports